import { Component, Inject, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';
import { CognitoUtil } from '../../../shared/services/cognito.service';
import { EguardValidationService } from '../../../../core/components/validation/validation.service';
import {PasswordStrengthService} from '../../../shared/services/password.strength' ; 

@Component({
    selector: 'eguard-change-password-form',
    templateUrl: './change-password.component.html'
})
export class EguardChangePasswordComponent implements OnInit, OnDestroy {
    changePasswordForm: any;

    password = new PasswordStrengthService() ; 
    constructor(
        public dialogRef: MatDialogRef<EguardChangePasswordComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private formBuilder: FormBuilder,
        public dialog: MatDialog,
        public snackBar: MatSnackBar,
        private cognito: CognitoUtil) {
        this.createForm();
    }
    ngOnInit() {
        // this.changePasswordForm.patchValue(this.data);
    }
    onNoClick(): void {
        this.dialogRef.close();
    }
    ngOnDestroy() {
        this.snackBar.dismiss();
    }

    onKey($event) {
        this.password.onKey($event) ; 
    }

    createForm() {
        this.changePasswordForm = this.formBuilder.group({
            currentPassword: ['', [Validators.required]],
            newPassword: ['', [Validators.required]],
            confirmPassword: ['', [Validators.required]]
        },   {
      validator: EguardValidationService.MatchPassword // your validation method
    });
    }

    updatePassword() {
        const passwordForm = this.changePasswordForm.value;
        this.cognito.changePassword(
            passwordForm.currentPassword,
            passwordForm.newPassword,
            this
        );
    }

    cognitoCallback(message: string, result: any) {

            switch (message) {
                case 'SUCCESS':
                    this.dialogRef.close('Password updated successfully.');
                    setTimeout(() => {
                        this.snackBar.open('Password updated successfully.', null, {
                            extraClasses: ['success-snackbar'],
                            duration: 5000
                        });
                    }, 1000);
                break;
                case 'Error':
                    if(result.message == 'Password did not conform with policy: Password not long enough') {
                        this.snackBar.open('Password must be at least 8 characters long with a uppercase, lowercase, special character & number.', null, {
                            extraClasses: ['error-snackbar'],
                            duration: 5000
                        });
                    }
                    else if(result.message == 'Incorrect username or password.') {
                        this.snackBar.open('Current Password is incorrect.', null, {
                            extraClasses: ['error-snackbar'],
                            duration: 5000
                        });
                    }
                    else {
                        this.snackBar.open(result.message, null, {
                            extraClasses: ['error-snackbar'],
                            duration: 5000
                        });
                    }
                break;
                default:
                    
            }
    }
    
}



// WEBPACK FOOTER //
// ./src/app/main/content/common/change-password/change-password.component.ts